import { t } from 'src/i18n';
import type { EmergencyCauseCategoryOption } from 'src/outskirts/account/emergency/emergency-view-model';

// `text`-feltene er lazy gettere slik at i18n-`t()` kjøres ved oppslag (kalltid),
// ikke ved import. `value` er enum-koder som sammenliknes i koden — uoversatt.
export const emergencyCauseCategories: EmergencyCauseCategoryOption[] = [
  {
    value: 'MAJOR_ACCIDENT',
    get text() {
      return t('emergency.causeCategories.majorAccident');
    },
  },
  {
    value: 'NATURAL_DISASTER',
    get text() {
      return t('emergency.causeCategories.naturalDisaster');
    },
  },
  {
    value: 'WAR_AND_TERROR',
    get text() {
      return t('emergency.causeCategories.warAndTerror');
    },
  },
  {
    value: 'CYBER_ATTACK',
    get text() {
      return t('emergency.causeCategories.cyberAttack');
    },
  },
  {
    value: 'EPIDEMIC',
    get text() {
      return t('emergency.causeCategories.epidemic');
    },
  },
  {
    value: 'HAZARDOUS_DISCHARGE',
    get text() {
      return t('emergency.causeCategories.hazardousDischarge');
    },
  },
];
